import * as Sentry from '@sentry/vue'
import { app } from '@/main'

let isInitialized = false

/**
 * Initializes Sentry after the host page grants analytics consent.
 */
export function initializeSentry(): void {
  if (isInitialized) return

  Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_SENTRY_ENV,
    debug: false,
    dataCollection: {
      userInfo: false,
      cookies: false,
      httpHeaders: { request: false, response: false },
      httpBodies: [],
      queryParams: false,
      genAI: { inputs: false, outputs: false },
      stackFrameVariables: false
    },
    enabled: import.meta.env.VITE_SENTRY_DSN !== undefined && import.meta.env.VITE_SENTRY_ENV !== undefined
  })

  isInitialized = true
}

/**
 * Stops Sentry when analytics consent is revoked.
 */
export function teardownSentry(): void {
  if (!isInitialized) return

  void Sentry.close()
  isInitialized = false
}
